import { useCallback } from 'react';
import { LOADING_STATUS } from 'shared/constants';
import { useOperations as useUserOperations } from 'store/features/user';

import { useGetUserGeolocation } from 'entities/application';

export const useGetGeoPosition = () => {
  const { setUserGeoPosition, setUserGeoPositionStatusLoading } = useUserOperations();
  const getUserGeolocation = useGetUserGeolocation();

  const getPosition = useCallback(async () => {
    try {
      setUserGeoPositionStatusLoading(LOADING_STATUS.load);

      const { coords: { latitude: lat, longitude: lng } } = await getUserGeolocation();
      setUserGeoPosition({ lat, lng });
    } catch (e) {}
    finally {
      setUserGeoPositionStatusLoading(LOADING_STATUS.done);
    }
    
  }, [setUserGeoPosition, setUserGeoPositionStatusLoading, getUserGeolocation]);

  return getPosition;
};
